import { motion } from 'framer-motion';
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { getAssetPathAndSize } from 'utils';
import { months } from './meta';
import styles from "./Results.module.css";
import he from "he";

type TLargeCardProps = {
    id: string;
    tileWidth: string;
    Name: string;
    Url: Location;
    index: number;
    variant: { [key: string]: any };
    isDesktop: boolean;
    Img: { Src: string };
    Abstract: string;
    ReadTime?: string;
    PublicationDate?: string;
    ShowPublicationDateReadTimeContentType: boolean;
    ContentType?: null | { [key: string]: string };
    FeaturedText?: string | null

}

export const LargeCard: FC<TLargeCardProps> = ({
    ShowPublicationDateReadTimeContentType,
    PublicationDate,
    ReadTime,
    id,
    tileWidth,
    Name,
    Url,
    index,
    variant,
    isDesktop,
    Img,
    Abstract,
    ContentType,
    FeaturedText
}) => {
    const [hovered, setHovered] = useState<boolean>(false);
    const [h, setH] = useState<number>(0);
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (ref.current && isDesktop) {
            const height = ref.current.clientHeight;
            setH(height);
        }

    }, [ref]);

    const timeStamp = PublicationDate?.match(/[\d]+/)[0];
    const date = timeStamp && new Date(parseInt(timeStamp));
    const dateFormatted = date && `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;

    const publicationDateReadTimeContentTypeNode = <motion.span className="standard-card-label">{PublicationDate && dateFormatted}{ReadTime && (' | ' + ReadTime + ' min read')}{Boolean(ContentType) && (' | ' + ContentType.ContentTypeName)}</motion.span>;

    return (
        <motion.div
            style={{ cursor: 'pointer' }}
            onClick={() => window.location = Url}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <motion.div
                className={styles.contentWrapper}
                variants={variant}
                exit="exit"
                initial="hidden"
                animate="visible">
                <motion.img
                    className={styles.img}
                    animate={{ scale: hovered ? 1.1 : 1 }}
                    transition={{ type: "tween", duration: 0.4 }}
                    alt={Name}
                    src={isDesktop ? getAssetPathAndSize(Img.Src, 70) : getAssetPathAndSize(Img.Src, 100, 2.5)}
                />

                <motion.div animate={{
                    background:
                        'linear-gradient(0deg, rgba(22, 24, 20, 0.75) 40%, transparent)'
                }}
                    className={styles.content}>
                    <motion.div
                        initial={{ y: 0 }}
                        animate={{ y: hovered ? 0 : h }}
                        transition={{ type: "tween", duration: 0.4 }}
                    >
                        {Boolean(FeaturedText) ?
                            <span className="featured-series-label">{he.decode(FeaturedText)}</span>
                            :
                            ShowPublicationDateReadTimeContentType && publicationDateReadTimeContentTypeNode
                        }
                        <motion.h2 >{Name}</motion.h2>
                        <div className="LargeCardRef" ref={ref}>
                            <motion.p
                                dangerouslySetInnerHTML={{__html: Abstract}}
                                initial={{ opacity: 0 }}
                                animate={{ opacity:  isDesktop ? hovered ? 1 : 0 : 1 }} ></motion.p>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}


